import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface Toast {
  text: string;
  classname: string;
  delay: number;
}

@Injectable({ providedIn: 'root' })
export class ToastrService {
  private toastSubject = new Subject<Toast>();
  toast$ = this.toastSubject.asObservable();

  showSuccess(msg: string) {
    this.toastSubject.next({ text: msg, classname: 'bg-success text-light', delay: 4000 });
  }

  showError(msg: string) {
    this.toastSubject.next({ text: msg, classname: 'bg-danger text-light', delay: 4000 });
  }

  showWarning(msg: string) {
    this.toastSubject.next({ text: msg, classname: 'bg-warning text-dark', delay: 4000 });
  }

  showInfo(msg: string) {
    this.toastSubject.next({ text: msg, classname: 'bg-info text-light', delay: 4000 });
  }
}
